// extracted by mini-css-extract-plugin
export var startGrid = "RecentPosts-module--startGrid--v-NVr";
export var wrapper = "RecentPosts-module--wrapper--Qiv3X";